import React from "react";
import { BASE_URL } from "../constant/apiUrl";
import Loading from "../utils/Loader";
import InternalPageLayout from "../components/InternalPages/InternalPageLayout";
import DefaultPage from "../components/Administration/Screens/DefaultPage";
import { HEADER_CONSTANT } from "../constant/constant";

import { useSelector } from "react-redux";
import { setSpecialProject } from "../slices/internalPageSlice";
import useFetchInternal from "../hooks/useFetchInternal";

function SpeacialProject() {
  const { specialProject } = useSelector((store) => store.internalPage);

  const { loading } = useFetchInternal(
    `${BASE_URL}/special-projects/screen/find-all`,
    setSpecialProject,
    specialProject,
    "Special_Project"
  );

  if (loading) return <Loading data-testid="loading" />;

  return (
    <>
      {specialProject?.internalSubPages?.length > 0 ? (
        <InternalPageLayout
          pageData={specialProject}
          header={HEADER_CONSTANT.special_project}
          showDropdown={true}
          data-testid="special-project-container"
        />
      ) : (
        <DefaultPage
          text={"You are not assigned to any Special Project"}
          data-testid="default-page"
        />
      )}
    </>
  );
}

export default SpeacialProject;
